import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "commands-shortcuts" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_CommandsDesktop = _resolveComponent("CommandsDesktop")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.shortcut_groups, (group, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: group.title,
        class: "shortcut",
        style: _normalizeStyle({'--shortcut-delay': `${900 + index * 200}ms`})
      }, [
        _createVNode(_component_CommandsDesktop, {
          disabled: !group.items.length,
          skills: group.items,
          sources: [],
          onSkill: _cache[0] || (_cache[0] = $event => (_ctx.$emit('skill', $event)))
        }, {
          reference: _withCtx(({visible}) => [
            _createVNode(_component_Button, {
              class: _normalizeClass(["shortcut-button", {active: visible}]),
              round: "",
              gap: "0.8rem",
              disabled: !group.items.length
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  icon: group.icon,
                  size: "2rem",
                  stroke: "var(--brand-700)",
                  "stroke-width": "1"
                }, null, 8 /* PROPS */, ["icon"]),
                _createTextVNode(" " + _toDisplayString(group.title), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "disabled"])
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "skills"])
      ], 4 /* STYLE */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}